import Modal from '@scripts/util/Modal.js';
import Breakpoints from '@scripts/util/Breakpoints.js';
import AnimatedVideoHero from '@scripts/modules/AnimatedVideoHero.js';

let teaserContainer, fullVideoButton, fullVideoInstance, videoIds;

export default {

  init() {

    initWistiaVideos();

    AnimatedVideoHero.init(document.querySelector('.animated-video-hero'));

  }
}

/**
 * Initialize the hero wistia videos
 */
function initWistiaVideos() {

  teaserContainer = document.querySelector('.animated-video-hero [data-teaser-container]');
  if(!teaserContainer) return;

  videoIds = {
    mobile: teaserContainer.dataset.mobileVideoId,
    tablet: teaserContainer.dataset.tabletVideoId,
    desktop: teaserContainer.dataset.desktopVideoId,
  }

  new Breakpoints({
    'default': () => { loadWistiaTeaser(videoIds.mobile) },
    'md': () => { loadWistiaTeaser(videoIds.tablet) },
    'lg': () => { loadWistiaTeaser(videoIds.desktop) },
  });

  fullVideoButton = document.getElementById('hero-teaser-video-button');
  if(fullVideoButton) {
    initFullVideoModal();
  }

}

/**
 * Load the wistia teaser
 * @param {string} videoId - The video ID of the teaser video
 */
function loadWistiaTeaser(videoId) {

  if (!videoId || !teaserContainer) return;

  // Inject the wistia embed
  teaserContainer.innerHTML = `<div class="wistia_embed wistia_async_${videoId}"
    data-muted="true"
    data-autoplay="true"
    data-controls="false"
    data-controlsvisibleonload="false"
    data-chromeless="true"
    data-wmode="transparent"></div>`;

  window._wq = window._wq || [];
  window._wq.push({
    id: videoId,
    onReady: function(video) {
      video.mute();
      video.play();
      // Loop the first 8 seconds
      video.bind('timechange', function(t) {
        if (t && t > 8) {
          video.time(0); // rewind
          video.play();
        }
      });
    },
  });

}

/**
 * Initialize the full video modal
 */
function initFullVideoModal() {
  const videoModal = new Modal(fullVideoButton, 'video-modal');
  const fullVideoId = fullVideoButton.dataset.fullVideoId;

  const fauxButton = document.querySelector('.hero-teaser-faux-button');
  if(fauxButton) {
    fauxButton.addEventListener('click', () => {
      videoModal.openModal();
    });
  }

  videoModal.onOpenCallback = () => {

    // Play if the video is already loaded
    if(videoModal.detail.state == 'keep') {
      fullVideoInstance.play();
    }
    // Load the Wistia video
    else {

      videoModal.dataSlot.querySelector('.full-video-wrapper').innerHTML = `<div class="wistia_embed wistia_async_${fullVideoId} videoFoam=true size-full object-cover"></div>`;
      window._wq = window._wq || [];
      window._wq.push({
        id: fullVideoId,
        onReady: function(video) {

          fullVideoInstance = video;
          video.play();
        },
      });


    }
  }

  // Pause the video when the modal is closed
  videoModal.onCloseCallback = () => {
    if(fullVideoInstance) {
      fullVideoInstance.pause();
    }
  }
}
